import * as React from 'react'
import { Autocomplete, TextField, Chip, Box } from '@mui/material'
import CancelIcon from '@mui/icons-material/Cancel'

const AutocompleteComponent = ({
  type,
  valueList,
  onChange,
  options,
  placeholder,
  autoRef,
  ...rest
}) => {
  return (
    <Autocomplete
      ref={autoRef}
      id={`autocomplete-search-${type}`}
      name={`searchBy${type}`}
      limitTags={10}
      size="small"
      value={valueList}
      onChange={onChange}
      options={options}
      clearText="Limpiar"
      openText="Abrir"
      closeText="Cerrar"
      noOptionsText={`No es una opción`}
      getOptionLabel={option => option.title}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={params => <TextField {...params} placeholder={placeholder} />}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => {
          return (
            <Chip
              key={`chip-${type}-${index}`}
              variant="outlined"
              label={option.title}
              size="small"
              deleteIcon={valueList.length > 1 ? <CancelIcon /> : <Box />}
              {...getTagProps({ index })}
            />
          )
        })
      }
      {...rest}
    />
  )
}
export default AutocompleteComponent
